import ReactQuill, { Quill } from "react-quill";
import React, { useRef } from "react";
import styled from "@emotion/styled";

const QuillWrapper = styled.div`
  .ql-editor b {font-weight: bold;}
  .ql-editor i {font-style: italic;}
  .ql-toolbar {display: none;}
  .ql-container {border: 0; padding: 0 4px;}
  .ql-editor {padding: 3px; min-height: 100px; height: inherit;}
`;
export default function ArcEditorView(props: any) {
  const quillInstance: any = useRef(null);

  // apply bold option
  const bold = Quill.import('formats/bold');
  bold.tagName = 'b';
  Quill.register(bold, true);

  // apply italic option
  const italic = Quill.import('formats/italic');
  italic.tagName = 'i';
  Quill.register(italic, true);

  return (<QuillWrapper>
    <ReactQuill theme="snow"
      ref={quillInstance}
      value={props.value}
      readOnly={true}
      style={{ height: "inherit", paddingBottom: "42px" }}
    />
  </QuillWrapper>);
}